// FROM http://mcg.mbitson.com/#!?lightBlue=%2347b3e6&blue=%234483c4&blueGrey=%23677789&grey=%23323f4d&turq=%23356e7b&green=%2325ab6a&red=%23f22613&purple=%238f5fa0&yellow=%23f4ab34&orange=%23e65100&themename=tm3
const colours = {
  lightBlue500: '#47b3e6',
  green500: '#25ab6a',
  red500: '#ef5350',
  purple500: '#8f5fa0',
  yellow500: '#f4ab34',
  blue500: '#4483c4',
  blueGrey500: '#677789',
  lightGreen500: '#cddc39',
  grey500: '#323f4d',
  orange500: '#e65100',
  turq500: '#356e7b',

  lightBlue900: '#208bd5',
  green900: '#0d803c',
  red900: '#e42927',
  purple900: '#603273',
  yellow900: '#ec8015',
  blue900: '#1f53a2',
  blueGrey900: '#394759',
  lightGreen900: '#aec517',
  grey900: '#131b25',
  orange900: '#d52700',
  turq900: '#163f4b',

  lightBlue300: '#7ecaee',
  green300: '#66c497',
  red300: '#f48785',
  purple300: '#b18fbd',
  yellow300: '#f7c471',
  blue300: '#7ca8d6',
  blueGrey300: '#95a0ac',
  lightGreen300: '#dce774',
  grey300: '#707982',
  orange300: '#ee854d',
  turq300: '#729aa3'
};

export default colours;
export { colours };
export { colours as Colours };
export { colours as Colors }; //material-ui replacement
